import React from 'react';

const ColorScale = ({ classes }) => <div className={classes.root} />;

export default ColorScale;
